// trigger that copies the value from Xplor_ChildAddress to Xplor_PCAddress
const defaultSchema = {
  triggers: [
    {
      type: 'copyvalue',
      expression: '{Xplor_SameAsChildAddress} notempty',
      setToName: 'Xplor_PCAddress',
      fromName: 'Xplor_ChildAddress'
    }
  ],
  pages: [
    {
      // page 1
      name: 'Child Details',
      elements: [
        {
          type: 'panel',
          name: 'Xplor_ChildDetailsPanel',
          elements: [
            {
              type: 'text',
              name: 'XplorRequired_ChildFirstName',
              title: 'First Name',
              isRequired: true
            },
            {
              type: 'text',
              name: 'Xplor_ChildMiddleName',
              startWithNewLine: false,
              title: 'Middle Name'
            },
            {
              type: 'text',
              name: 'XplorRequired_ChildLastName',
              startWithNewLine: false,
              title: 'Last Name',
              isRequired: true
            },
            {
              type: 'text',
              name: 'Xplor_ChildDOB',
              title: 'Date of Birth'
            },
            {
              type: 'dropdown',
              name: 'Xplor_ChildGender',
              startWithNewLine: false,
              title: 'Gender at Birth',
              choices: ['Female', 'Male']
            },
            {
              type: 'dropdown',
              name: 'Xplor_ChildGenderIdentity',
              title: 'Gender Identity',
              choices: ['Female', 'Male', 'Non-Binary', 'Trans Female', 'Trans Male']
            },
            {
              type: 'dropdown',
              name: 'Xplor_ChildPronouns',
              startWithNewLine: false,
              choices: ['He/Him', 'She/Her', 'They/Them'],
              title: 'Pronouns'
            },
            {
              type: 'text',
              name: 'Xplor_ChildTFCCode',
              title: 'Child TFC Code',
              validators: [
                {
                  type: 'regex',
                  text: 'Child TFC code is not valid.',
                  regex: '(^[0-9]{13})'
                }
              ]
            },
            {
              type: 'text',
              name: 'Xplor_ChildAddress',
              title: 'Child\'s Home Address'
            },
            {
              type: 'file',
              name: 'Xplor_ChildChildPhoto',
              startWithNewLine: true,
              title: 'Upload your child\'s profile photo.',
              showPreview: false,
              maxSize: 5242880
            },
            {
              type: 'checkbox',
              name: 'Xplor_ChildHasCourtOrder',
              title: 'Court Orders',
              choices: [
                {
                  value: 'hasCourtOrder',
                  text: 'Are there any court appointed orders relating to this enrolment?'
                }
              ],
              colCount: 0
            },
            {
              type: 'file',
              name: 'Xplor_ChildCourtOrders',
              visible: false,
              visibleIf: '{Xplor_ChildHasCourtOrder} = ["hasCourtOrder"]',
              startWithNewLine: false,
              title: 'Please add a copy of your court orders',
              enableIf: '{Xplor_ChildHasCourtOrder} = ["hasCourtOrder"]',
              showPreview: false,
              maxSize: 5242880
            },
            {
              type: 'checkbox',
              name: 'Xplor_ChildHasParentingOrders',
              title: 'Parenting Orders',
              choices: [
                {
                  value: 'hasParentingOrders',
                  text: 'Are there any parenting orders relating to this enrolment?'
                }
              ],
              colCount: 0
            },
            {
              type: 'file',
              name: 'Xplor_ChildParentingOrders',
              visible: false,
              visibleIf: '{Xplor_ChildHasParentingOrders} = ["hasParentingOrders"]',
              startWithNewLine: false,
              title: 'Please add a copy of your parenting orders',
              enableIf: '{Xplor_ChildHasParentingOrders} = ["hasParentingOrders"]',
              showPreview: false,
              maxSize: 5242880
            },
            {
              type: 'comment',
              name: 'Xplor_ChildSpecial',
              title: 'Additional Comments'
            }
          ],
          title: 'Child Details'
        },
        {
          type: 'panel',
          name: 'Xplor_ChildCulturalBackgroundPanel',
          elements: [
            {
              type: 'text',
              name: 'Xplor_ChildCulturalBackground',
              title: 'What is your child\'s cultural background?'
            },
            {
              type: 'text',
              name: 'Xplor_ChildLanguage',
              startWithNewLine: false,
              title: 'What language is spoken at home?'
            },
            {
              type: 'checkbox',
              name: 'Xplor_ChildHasCulturalRequirements',
              title: 'Cultural Requirements',
              choices: [
                {
                  value: 'hasCulturalRequirements',
                  text: 'Does your child have any cultural requirements?'
                }
              ]
            },
            {
              type: 'text',
              name: 'Xplor_ChildCulturalRequirements',
              titleLocation: 'hidden',
              visible: false,
              visibleIf: '{Xplor_ChildHasCulturalRequirements} = ["hasCulturalRequirements"]',
              startWithNewLine: false,
              placeHolder: 'Please provide further details',
              enableIf: '{Xplor_ChildHasCulturalRequirements} = ["hasCulturalRequirements"]'
            },
            {
              type: 'checkbox',
              name: 'Xplor_ChildHasReligiousRequirements',
              title: 'Religious Requirements',
              choices: [
                {
                  value: 'hasReligiousRequirements',
                  text: 'Does your child have any religious requirements?'
                }
              ]
            },
            {
              type: 'dropdown',
              name: 'Xplor_ChildReligion',
              visible: false,
              visibleIf: '{Xplor_ChildHasReligiousRequirements} = ["hasReligiousRequirements"]',
              startWithNewLine: false,
              enableIf: '{Xplor_ChildHasReligiousRequirements} = ["hasReligiousRequirements"]',
              titleLocation: 'hidden',
              choices: [
                'Catholic',
                'Christianity',
                {
                  value: 'Islam',
                  text: ' Islam'
                },
                'Secular/Nonreligious/Agnostic/Atheist',
                'Hinduism',
                'Chinese traditional religion',
                'Buddhism',
                'primal-indigenous',
                'African Traditional & Diasporic',
                'Sikhism',
                'Juche',
                'Spiritism',
                'Judaism',
                'Lutheran',
                'Anglican',
                {
                  value: 'Baha',
                  text: 'Baha\'i'
                },
                'Jainism',
                'Shinto',
                'Cao Dai',
                'Zoroastrianism',
                'Tenrikyo',
                'Neo-Paganism',
                'Unitarian-Universalism',
                'Rastafarianism',
                'Scientology'
              ],
              optionsCaption: 'Religion'
            }
          ],
          title: 'Cultural Background'
        },
        {
          type: 'panel',
          name: 'Xplor_BookingDetailsPanel',
          elements: [
            {
              type: 'text',
              name: 'XplorRequired_IntendedStartDate',
              title: 'Intended Start Date',
              isRequired: true
            },
            {
              type: 'checkbox',
              name: 'Xplor_IntendedAM',
              title: 'Which MORNINGS would you prefer to attend?',
              choices: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
              colCount: 0
            },
            {
              type: 'checkbox',
              name: 'Xplor_IntendedPM',
              title: 'Which AFTERNOONS would you prefer to attend?',
              choices: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
              colCount: 0
            }
          ],
          title: 'Booking Details'
        },
        {
          type: 'panel',
          name: 'Xplor_HealthInformationPanel',
          elements: [
            {
              type: 'text',
              name: 'Xplor_ChildHealthCentre',
              title: 'Maternal & Child Health Centre'
            },
            {
              type: 'text',
              name: 'Xplor_ChildMedicalPractitionerName',
              startWithNewLine: false,
              title: 'Medical Practitioner Name'
            },
            {
              type: 'text',
              name: 'Xplor_ChildMedicalPractitionerPhone',
              startWithNewLine: false,
              title: 'Medical Practitioner Phone Number'
            },
            {
              type: 'text',
              name: 'Xplor_MedicalPractitionerAddress',
              title: 'Medical Practitioner Address'
            },
            {
              type: 'checkbox',
              name: 'Xplor_ChildHasHealthRecord',
              title: 'Health Record',
              choices: [
                {
                  value: 'hasHealthRecord',
                  text: 'Does your child have a Health Record?'
                }
              ]
            },
            {
              type: 'file',
              name: 'Xplor_ChildHealthRecord',
              visible: false,
              visibleIf: '{Xplor_ChildHasHealthRecord} = ["hasHealthRecord"]',
              startWithNewLine: false,
              title: 'Please add a copy of your Health Record',
              enableIf: '{Xplor_ChildHasHealthRecord} = ["hasHealthRecord"]',
              showPreview: false,
              maxSize: 5242880
            },
            {
              type: 'checkbox',
              name: 'Xplor_ChildHasImmunised',
              title: 'Immunisation',
              choices: [
                {
                  value: 'hasImmunised',
                  text: 'Has your child been immunised?'
                }
              ]
            },
            {
              type: 'file',
              name: 'Xplor_ChildImmunisedRecord',
              visibleIf: '{Xplor_ChildHasImmunised} = ["hasImmunised"]',
              startWithNewLine: false,
              title: 'Please add a copy of your immunisation record',
              enableIf: '{Xplor_ChildHasImmunised} = ["hasImmunised"]',
              showPreview: false,
              maxSize: 5242880
            },
            {
              type: 'checkbox',
              name: 'Xplor_ChildHasMedicine',
              title: 'Medication',
              choices: [
                {
                  value: 'hasMedicine',
                  text: 'Is your child receiving regular prescribed medicine?'
                }
              ]
            },
            {
              type: 'text',
              name: 'Xplor_ChildMedicine',
              titleLocation: 'hidden',
              visibleIf: '{Xplor_ChildHasMedicine} = ["hasMedicine"]',
              startWithNewLine: false,
              placeHolder: 'Please provide further details',
              enableIf: '{Xplor_ChildHasMedicine} = ["hasMedicine"]'
            },
            {
              type: 'checkbox',
              name: 'Xplor_ChildHasMedicalAllergies',
              title: 'Allergies',
              choices: [
                {
                  value: 'hasMedicalAllergies',
                  text: 'Does your child have any medical allergies?'
                }
              ]
            },
            {
              type: 'checkbox',
              name: 'Xplor_ChildMedicalAllergies',
              visibleIf: '{Xplor_ChildHasMedicalAllergies} = ["hasMedicalAllergies"]',
              startWithNewLine: false,
              enableIf: '{Xplor_ChildHasMedicalAllergies} = ["hasMedicalAllergies"]',
              titleLocation: 'hidden',
              choices: [
                'Peanut',
                'Tree nuts',
                'Milk',
                'Eggs',
                'Sesame',
                'Fish',
                'Shellfish',
                'Soy',
                'Wheat',
                'Lupin'
              ],
              colCount: 2
            },
            {
              type: 'checkbox',
              name: 'Xplor_ChildHasOtherAllergies',
              title: 'Additional Information on allergies',
              choices: [
                {
                  value: 'hasOtherAllergies',
                  text: 'Do you want to add additional allergy information?'
                }
              ]
            },
            {
              type: 'comment',
              name: 'Xplor_ChildOtherAllergies',
              titleLocation: 'hidden',
              visibleIf: '{Xplor_ChildHasOtherAllergies} = ["hasOtherAllergies"]',
              startWithNewLine: false,
              placeHolder: 'Please provide further details',
              enableIf: '{Xplor_ChildHasOtherAllergies} = ["hasOtherAllergies"]'
            },
            {
              type: 'checkbox',
              name: 'Xplor_ChildHasAnaphylaxis',
              title: 'Anaphylaxis',
              choices: [
                {
                  value: 'hasAnaphylaxis',
                  text: 'Has your child been diagnosed or at risk of anaphylaxis?'
                }
              ]
            },
            {
              type: 'file',
              name: 'Xplor_ChildAnaphylaxisPlan',
              visibleIf: '{Xplor_ChildHasAnaphylaxis} = ["hasAnaphylaxis"]',
              startWithNewLine: false,
              title: 'Please add a copy of your anaphylaxis action plan',
              enableIf: '{Xplor_ChildHasAnaphylaxis} = ["hasAnaphylaxis"]',
              showPreview: false,
              maxSize: 5242880
            },
            {
              type: 'checkbox',
              name: 'Xplor_ChildHasEpipen',
              title: 'Anaphylaxis Prescription',
              choices: [
                {
                  value: 'hasEpipen',
                  text: 'Does your child have an epipen or anapen?'
                }
              ]
            },
            {
              type: 'checkbox',
              name: 'Xplor_ChildHasOtherHealth',
              title: 'Other Health Conditions',
              choices: [
                {
                  value: 'hasOtherHealth',
                  text: 'Does your child have any other health conditions?'
                }
              ]
            },
            {
              type: 'text',
              name: 'Xplor_ChildOtherHealth',
              visibleIf: '{Xplor_ChildHasOtherHealth} = ["hasOtherHealth"]',
              startWithNewLine: false,
              enableIf: '{Xplor_ChildHasOtherHealth} = ["hasOtherHealth"]',
              titleLocation: 'hidden',
              placeHolder: 'Please provide further details'
            },
            {
              type: 'checkbox',
              name: 'Xplor_ChildHasDietary',
              title: 'Dietary Requirements',
              choices: [
                {
                  value: 'hasDietary',
                  text: 'Does your child have any dietary requirements?'
                }
              ]
            },
            {
              type: 'checkbox',
              name: 'Xplor_ChildDietary',
              visibleIf: '{Xplor_ChildHasDietary} = ["hasDietary"]',
              startWithNewLine: false,
              enableIf: '{Xplor_ChildHasDietary} = ["hasDietary"]',
              titleLocation: 'hidden',
              choices: [
                { text: 'Gluten free and coeliac', value: 'GFML' },
                { text: 'Dairy free and lactose free', value: 'NLML' },
                { text: 'Vegetarian', value: 'VGML' },
                { text: 'Vegan', value: 'VVML' },
                { text: 'FODMAP', value: 'FODMAP' },
                { text: 'Tree nut and peanut allergies', value: 'Tree nut and peanut allergies' },
                { text: 'Fish and shellfish allergies', value: 'Fish and shellfish allergies' }
              ],
              colCount: 2
            },
            {
              type: 'checkbox',
              name: 'Xplor_ChildHasAsthma',
              title: 'Asthma',
              choices: [
                {
                  value: 'hasAsthma',
                  text: 'Does your child have asthma?'
                }
              ]
            },
            {
              type: 'file',
              name: 'Xplor_ChildAsthma',
              visibleIf: '{Xplor_ChildHasAsthma} = ["hasAsthma"]',
              startWithNewLine: false,
              title: 'Please add a copy of your asthma action plan',
              enableIf: '{Xplor_ChildHasAsthma} = ["hasAsthma"]',
              showPreview: false,
              maxSize: 5242880
            },
            {
              type: 'checkbox',
              name: 'Xplor_ChildHasBirthCert',
              title: 'Birth Certificate',
              choices: [
                {
                  value: 'hasBirthCert',
                  text: 'Does your child have a birth certificate?'
                }
              ]
            },
            {
              type: 'file',
              name: 'Xplor_ChildBirthCert',
              visibleIf: '{Xplor_ChildHasBirthCert} = ["hasBirthCert"]',
              startWithNewLine: false,
              title: 'Please add a copy of your child\'s birth certificate',
              enableIf: '{Xplor_ChildHasBirthCert} = ["hasBirthCert"]',
              showPreview: false,
              maxSize: 5242880
            }
          ],
          title: 'Health Information'
        }
      ]
    },
    {
      // page2
      name: 'Parent Details',
      elements: [
        {
          type: 'panel',
          name: 'Xplor_PrimaryCarerPanel',
          elements: [
            {
              type: 'text',
              name: 'XplorRequired_PCFirstName',
              title: 'First Name',
              isRequired: true
            },
            {
              type: 'text',
              name: 'Xplor_PCMiddleName',
              startWithNewLine: false,
              title: 'Middle Name'
            },
            {
              type: 'text',
              name: 'XplorRequired_PCLastName',
              startWithNewLine: false,
              title: 'Last Name',
              isRequired: true
            },
            {
              type: 'text',
              name: 'Xplor_PCDOB',
              title: 'Date of Birth'
            },
            {
              type: 'dropdown',
              name: 'Xplor_PCGender',
              title: 'Gender Identity',
              choices: ['Female', 'Male', 'Non-Binary', 'Trans Female', 'Trans Male']
            },
            {
              type: 'dropdown',
              name: 'Xplor_PCGenderPronouns',
              startWithNewLine: false,
              title: 'Gender Pronouns',
              choices: ['He/Him', 'She/Her', 'They/Them']
            },
            {
              type: 'dropdown',
              name: 'Xplor_PCRelationship',
              startWithNewLine: false,
              title: 'Relationship',
              choices: [
                'Aunt',
                'Brother',
                'Carer',
                'Cousin',
                'Dentist',
                'Dept Officer',
                'Doctor',
                'Father',
                'Foster Father',
                'Foster Grandparent',
                'Foster Mother',
                'Foster Parent',
                'Friend',
                'God Parent',
                'Grandparent',
                'Guardian',
                'Minister',
                'Mother',
                'Neighbour',
                'Other',
                'Parent (Female)',
                'Parent (Male)',
                'Partner',
                'Relative',
                'Sibling',
                'Sister',
                'Social Worker',
                'Step Parent',
                'Uncle'
              ],
              placeHolder: 'Relationship'
            },
            {
              type: 'file',
              name: 'Xplor_PCPhoto',
              startWithNewLine: true,
              title: 'Upload your carer profile photo.',
              showPreview: false,
              maxSize: 5242880
            },
            {
              type: 'checkbox',
              name: 'Xplor_SameAsChildAddress',
              titleLocation: 'hidden',
              choices: [
                {
                  value: 'hasSameAsChildAddress',
                  text: 'Address is the same as Child\'s Home Address'
                }
              ],
              validators: [
                {
                  type: 'expression',
                  text: 'Primary Carer Address cannot be blank',
                  expression: '{Xplor_PCAddress} notempty'
                }
              ]
            },
            {
              type: 'text',
              name: 'Xplor_PCAddress',
              title: 'Address',
              visibleIf: '{Xplor_SameAsChildAddress} empty',
              isRequired: true
            },
            {
              type: 'text',
              name: 'XplorRequired_PCPhone',
              title: 'Phone Number',
              isRequired: true,
              validators: [
                {
                  type: 'regex',
                  regex: '^[\\+]?[(]?[0-9]{3}[)]?[-\\s\\.]?[0-9]{3}[-\\s\\.]?[0-9]{4,6}$',
                  text: 'Please enter a valid phone number.'
                }
              ]
            },
            {
              type: 'text',
              name: 'XplorRequired_PCEmail',
              startWithNewLine: false,
              title: 'Email Address',
              isRequired: true,
              validators: [
                {
                  type: 'email'
                }
              ]
            },
            {
              type: 'text',
              name: 'Xplor_PCOccupation',
              startWithNewLine: false,
              title: 'Occupation'
            },
            {
              type: 'text',
              name: 'Xplor_PCWorkAddress',
              title: 'Work Address'
            },
            {
              type: 'text',
              name: 'Xplor_PCWorkPhone',
              title: 'Work Phone Number'
            },
            {
              type: 'text',
              name: 'Xplor_PCWorkEmail',
              startWithNewLine: false,
              title: 'Work Email Address',
              validators: [
                {
                  type: 'email'
                }
              ]
            },
            {
              type: 'text',
              name: 'Xplor_PCCulturalBackground',
              title: 'What is your cultural background?'
            },
            {
              type: 'text',
              name: 'Xplor_PCLanguage',
              startWithNewLine: false,
              title: 'What language is spoken at home?'
            },
            {
              type: 'checkbox',
              name: 'Xplor_PC_Consent',
              title: 'Consent',
              choices: [
                {
                  value: 'pc_emergency_contact_consent',
                  text: 'I consent to be an emergency contact.'
                },
                {
                  value: 'pc_authorised_nominee_consent',
                  text: 'I consent to be an authorised nominee to collect this child.'
                },
                {
                  value: 'pc_medical_decision_consent',
                  text:
                    'I consent to be an authorised nominee to make medical decisions on behalf of this child.'
                },
                {
                  value: 'pc_excursion_consent',
                  text: 'I consent to be an authorised nominee for this child\'s incursions and excursions.'
                },
                {
                  value: 'pc_transport_consent',
                  text:
                    'I consent to be an authorised nominee to authorise the child being transported by the service or on transportation arranged by the service.'
                }
              ],
              colCount: 1
            }
          ],
          title: 'Primary Carer Details'
        },
        {
          type: 'panel',
          name: 'Xplor_AdditionalCarerPanel',
          elements: [
            {
              type: 'text',
              name: 'Xplor_ACFirstName',
              title: 'First Name'
            },
            {
              type: 'text',
              name: 'Xplor_ACMiddleName',
              startWithNewLine: false,
              title: 'Middle Name'
            },
            {
              type: 'text',
              name: 'Xplor_ACLastName',
              startWithNewLine: false,
              title: 'Last Name'
            },
            {
              type: 'text',
              name: 'Xplor_ACDOB',
              title: 'Date of Birth'
            },
            {
              type: 'dropdown',
              name: 'Xplor_ACGender',
              title: 'Gender Identity',
              choices: ['Female', 'Male', 'Non-Binary', 'Trans Female', 'Trans Male']
            },
            {
              type: 'dropdown',
              name: 'Xplor_ACGenderPronouns',
              startWithNewLine: false,
              title: 'Gender Pronouns',
              choices: ['He/Him', 'She/Her', 'They/Them']
            },
            {
              type: 'dropdown',
              name: 'Xplor_ACRelationship',
              startWithNewLine: false,
              title: 'Relationship',
              choices: [
                'Aunt',
                'Brother',
                'Carer',
                'Cousin',
                'Dentist',
                'Dept Officer',
                'Doctor',
                'Father',
                'Foster Father',
                'Foster Grandparent',
                'Foster Mother',
                'Foster Parent',
                'Friend',
                'God Parent',
                'Grandparent',
                'Guardian',
                'Minister',
                'Mother',
                'Neighbour',
                'Other',
                'Parent (Female)',
                'Parent (Male)',
                'Partner',
                'Relative',
                'Sibling',
                'Sister',
                'Social Worker',
                'Step Parent',
                'Uncle'
              ],
              placeHolder: 'Relationship'
            },
            {
              type: 'file',
              name: 'Xplor_ACPhoto',
              startWithNewLine: true,
              title: 'Upload your carer profile photo.',
              showPreview: false,
              maxSize: 5242880
            },
            {
              type: 'text',
              name: 'Xplor_ACAddress',
              title: 'Address'
            },
            {
              type: 'text',
              name: 'Xplor_ACPhone',
              title: 'Phone Number'
            },
            {
              type: 'text',
              name: 'Xplor_ACEmail',
              startWithNewLine: false,
              title: 'Email Address',
              validators: [
                {
                  type: 'email'
                }
              ]
            },
            {
              type: 'text',
              name: 'Xplor_ACOccupation',
              startWithNewLine: false,
              title: 'Occupation'
            },
            {
              type: 'text',
              name: 'Xplor_ACWorkAddress',
              title: 'Work Address'
            },
            {
              type: 'text',
              name: 'Xplor_ACWorkPhone',
              title: 'Work Phone Number'
            },
            {
              type: 'text',
              name: 'Xplor_ACWorkEmail',
              startWithNewLine: false,
              title: 'Work Email Address',
              validators: [
                {
                  type: 'email'
                }
              ]
            },
            {
              type: 'text',
              name: 'Xplor_ACCulturalBackground',
              title: 'What is your cultural background?'
            },
            {
              type: 'text',
              name: 'Xplor_ACLanguage',
              startWithNewLine: false,
              title: 'What language is spoken at home?'
            },
            {
              type: 'checkbox',
              name: 'Xplor_AC_Consent',
              title: 'Consent',
              choices: [
                {
                  value: 'ac_emergency_contact_consent',
                  text: 'I consent to be an emergency contact.'
                },
                {
                  value: 'ac_authorised_nominee_consent',
                  text: 'I consent to be an authorised nominee to collect this child.'
                },
                {
                  value: 'ac_medical_decision_consent',
                  text:
                    'I consent to be an authorised nominee to make medical decisions on behalf of this child.'
                },
                {
                  value: 'ac_excursion_consent',
                  text: 'I consent to be an authorised nominee for this child\'s incursions and excursions.'
                },
                {
                  value: 'ac_transport_consent',
                  text:
                    'I consent to be an authorised nominee to authorise the child being transported by the service or on transportation arranged by the service.'
                }
              ],
              colCount: 1
            }
          ],
          title: 'Additional Carer Details'
        }
      ]
    },
    {
      // page3
      name: 'Emergency Contact',
      elements: [
        {
          type: 'panel',
          name: 'Xplor_EC1Panel',
          elements: [
            {
              type: 'text',
              name: 'Xplor_EC1FirstName',
              title: 'First Name',
              requiredIf:
                '{Xplor_EC_Consent} anyof [\'ec_emergency_contact_consent\', \'ec_authorised_nominee_consent\', \'ec_medical_decision_consent\', \'ec_excursion_consent\', \'ec_transport_consent\']'
            },
            {
              type: 'text',
              name: 'Xplor_EC1MiddleName',
              startWithNewLine: false,
              title: 'Middle Name'
            },
            {
              type: 'text',
              name: 'Xplor_EC1LastName',
              startWithNewLine: false,
              title: 'Last Name',
              requiredIf:
                '{Xplor_EC_Consent} anyof [\'ec_emergency_contact_consent\', \'ec_authorised_nominee_consent\', \'ec_medical_decision_consent\', \'ec_excursion_consent\', \'ec_transport_consent\']'
            },
            {
              type: 'text',
              name: 'Xplor_EC1Phone',
              title: 'Phone Number',
              requiredIf:
                '{Xplor_EC_Consent} anyof [\'ec_emergency_contact_consent\', \'ec_authorised_nominee_consent\', \'ec_medical_decision_consent\', \'ec_excursion_consent\', \'ec_transport_consent\']'
            },
            {
              type: 'text',
              name: 'Xplor_EC1Email',
              startWithNewLine: false,
              title: 'Email Address',
              requiredIf:
                '{Xplor_EC_Consent} anyof [\'ec_emergency_contact_consent\', \'ec_authorised_nominee_consent\', \'ec_medical_decision_consent\', \'ec_excursion_consent\', \'ec_transport_consent\']',
              validators: [
                {
                  type: 'email'
                }
              ]
            },
            {
              type: 'dropdown',
              name: 'Xplor_EC1Relationship',
              startWithNewLine: false,
              title: 'Relationship',
              choices: [
                'Aunt',
                'Brother',
                'Carer',
                'Cousin',
                'Dentist',
                'Dept Officer',
                'Doctor',
                'Father',
                'Foster Father',
                'Foster Grandparent',
                'Foster Mother',
                'Foster Parent',
                'Friend',
                'God Parent',
                'Grandparent',
                'Guardian',
                'Minister',
                'Mother',
                'Neighbour',
                'Other',
                'Parent (Female)',
                'Parent (Male)',
                'Partner',
                'Relative',
                'Sibling',
                'Sister',
                'Social Worker',
                'Step Parent',
                'Uncle'
              ],
              placeHolder: 'Relationship'
            },
            {
              type: 'text',
              name: 'Xplor_EC1Address',
              title: 'Address',
              requiredIf:
                '{Xplor_EC_Consent} anyof [\'ec_emergency_contact_consent\', \'ec_authorised_nominee_consent\', \'ec_medical_decision_consent\', \'ec_excursion_consent\', \'ec_transport_consent\']'
            },
            {
              type: 'checkbox',
              name: 'Xplor_EC_Consent',
              title: 'Authorisation',
              choices: [
                {
                  value: 'ec_emergency_contact_consent',
                  text: 'I authorise this person to be an emergency contact.'
                },
                {
                  value: 'ec_authorised_nominee_consent',
                  text:
                    'I authorise this person to collect this child. This will give them access to the Hub to allow them to sign a child in and out.'
                },
                {
                  value: 'ec_medical_decision_consent',
                  text:
                    'I authorise this person to authorise administration of medication on behalf of this child.'
                },
                {
                  value: 'ec_excursion_consent',
                  text:
                    'I authorise this person to authorise an educator to take the child outside the education and care services premises.'
                },
                {
                  value: 'ec_transport_consent',
                  text:
                    'I authorise this person to authorise the child being transported by the service or on transportation arranged by the service.'
                }
              ],
              colCount: 1
            }
          ],
          title: 'Emergency Contact 1 Details'
        },
        {
          type: 'panel',
          name: 'Xplor_EC2Panel',
          elements: [
            {
              type: 'text',
              name: 'Xplor_EC2FirstName',
              title: 'First Name',
              requiredIf:
                '{Xplor_EC2_Consent} anyof [\'ec2_emergency_contact_consent\', \'ec2_authorised_nominee_consent\', \'ec2_medical_decision_consent\', \'ec2_excursion_consent\', \'ec2_transport_consent\']'
            },
            {
              type: 'text',
              name: 'Xplor_EC2MiddleName',
              startWithNewLine: false,
              title: 'Middle Name'
            },
            {
              type: 'text',
              name: 'Xplor_EC2LastName',
              startWithNewLine: false,
              title: 'Last Name',
              requiredIf:
                '{Xplor_EC2_Consent} anyof [\'ec2_emergency_contact_consent\', \'ec2_authorised_nominee_consent\', \'ec2_medical_decision_consent\', \'ec2_excursion_consent\', \'ec2_transport_consent\']'
            },
            {
              type: 'text',
              name: 'Xplor_EC2Phone',
              title: 'Phone Number',
              requiredIf:
                '{Xplor_EC2_Consent} anyof [\'ec2_emergency_contact_consent\', \'ec2_authorised_nominee_consent\', \'ec2_medical_decision_consent\', \'ec2_excursion_consent\', \'ec2_transport_consent\']'
            },
            {
              type: 'text',
              name: 'Xplor_EC2Email',
              startWithNewLine: false,
              title: 'Email Address',
              requiredIf:
                '{Xplor_EC2_Consent} anyof [\'ec2_emergency_contact_consent\', \'ec2_authorised_nominee_consent\', \'ec2_medical_decision_consent\', \'ec2_excursion_consent\', \'ec2_transport_consent\']',
              validators: [
                {
                  type: 'email'
                }
              ]
            },
            {
              type: 'dropdown',
              name: 'Xplor_EC2Relationship',
              startWithNewLine: false,
              title: 'Relationship',
              choices: [
                'Aunt',
                'Brother',
                'Carer',
                'Cousin',
                'Dentist',
                'Dept Officer',
                'Doctor',
                'Father',
                'Foster Father',
                'Foster Grandparent',
                'Foster Mother',
                'Foster Parent',
                'Friend',
                'God Parent',
                'Grandparent',
                'Guardian',
                'Minister',
                'Mother',
                'Neighbour',
                'Other',
                'Parent (Female)',
                'Parent (Male)',
                'Partner',
                'Relative',
                'Sibling',
                'Sister',
                'Social Worker',
                'Step Parent',
                'Uncle'
              ],
              placeHolder: 'Relationship'
            },
            {
              type: 'text',
              name: 'Xplor_EC2Address',
              title: 'Address',
              requiredIf:
                '{Xplor_EC2_Consent} anyof [\'ec2_emergency_contact_consent\', \'ec2_authorised_nominee_consent\', \'ec2_medical_decision_consent\', \'ec2_excursion_consent\', \'ec2_transport_consent\']'
            },
            {
              type: 'checkbox',
              name: 'Xplor_EC2_Consent',
              title: 'Authorisation',
              choices: [
                {
                  value: 'ec2_emergency_contact_consent',
                  text: 'I authorise this person to be an emergency contact.'
                },
                {
                  value: 'ec2_authorised_nominee_consent',
                  text:
                    'I authorise this person to collect this child. This will give them access to the Hub to allow them to sign a child in and out.'
                },
                {
                  value: 'ec2_medical_decision_consent',
                  text:
                    'I authorise this person to authorise administration of medication on behalf of this child.'
                },
                {
                  value: 'ec2_excursion_consent',
                  text:
                    'I authorise this person to authorise an educator to take the child outside the education and care services premises.'
                },
                {
                  value: 'ec2_transport_consent',
                  text:
                    'I authorise this person to authorise the child being transported by the service or on transportation arranged by the service.'
                }
              ],
              colCount: 1
            }
          ],
          title: 'Emergency Contact 2 Details'
        }
      ]
    },
    {
      // page4
      name: 'Declarations',
      elements: [
        {
          type: 'matrix',
          name: 'Consents',
          title: 'Consents',
          defaultValue: {
            seekMedicalTreatment: 'false',
            callAmbulance: 'false',
            takePhotos: 'false',
            giveHat: 'false',
            giveMedicine: 'false',
            applySunscreen: 'false',
            useEpipen: 'false',
            recordAttendance: 'false',
            shareInformation: 'false',
            useTechnology: 'false',
            excursions: 'false',
            displayPhoto: 'false',
            notifyChildCollection: 'false'
          },
          columns: [
            {
              value: 'true',
              text: 'Agree'
            },
            {
              value: 'false',
              text: 'Disagree'
            }
          ],
          rows: [
            {
              value: 'seekMedicalTreatment',
              text:
                'Do you consent for the service to seek medical treatment for your child from a medical practitioner, hospital or ambulance in the event you cannot be contacted?'
            },
            {
              value: 'callAmbulance',
              text: 'Do you consent for your child to be transported by an ambulance service?'
            },
            {
              value: 'takePhotos',
              text:
                'Do you consent for the service to take photographs and videos of your child during normal activities and excursions?'
            },
            {
              value: 'giveHat',
              text: 'Do you consent to provide your child with a sun safe hat for outdoor activities?'
            },
            {
              value: 'giveMedicine',
              text:
                'I give permission for educators with current first aid to administer paracetamol in an emergency in the correct dosage for the age of my child. Administration of this medication will only be given in the event of a parent being un-contactable in consultation with the director or nominated supervisor.'
            },
            {
              value: 'applySunscreen',
              text:
                'Do you consent for the service to apply sunscreen for your child before outdoor activities and excursions?'
            },
            {
              value: 'useEpipen',
              text:
                'Do you consent for the service to administer Ventolin or Epi-pen to your child in case of emergency?'
            },
            {
              value: 'recordAttendance',
              text:
                'I agree to accurately record the time of arrival and departure of my child from the service in accordance with the service requirements.'
            },
            {
              value: 'shareInformation',
              text:
                'I give permission for educators and school teachers/principals to share information about my child in relation to their care and wellbeing.'
            },
            {
              value: 'useTechnology',
              text: 'I give permission for my child to use/view technology (i.e. Tablet, TV, iPod)'
            },
            {
              value: 'excursions',
              text:
                'I give permission for my child to participate in regular local excursions from the service by foot.'
            },
            {
              value: 'displayPhoto',
              text: 'I give permission for my child\'s photo to be displayed in public places.'
            },
            {
              value: 'notifyChildCollection',
              text:
                'I agree to notify the service when my child is to be collected by any person other than those listed on this enrolment form in accordance with the services policies and procedures.'
            }
          ]
        },
        {
          name: 'XplorRequired_Consents_v2',
          title: 'Xplor Consents',
          defaultValue: {
            photoVideoConsent: 'false'
          },
          isRequired: true,
          rows: [
            {
              text:
                'Do you consent for the service to take photographs and videos of your child during normal activities and excursions for the purposes of recording their learning journey via the Xplor platform?',
              value: 'photoVideoConsent'
            }
          ],
          type: 'matrix',
          columns: [
            {
              text: 'Agree',
              value: 'true'
            },
            {
              text: 'Disagree',
              value: 'false'
            }
          ],
          isAllRowRequired: true
        },
        {
          type: 'matrix',
          name: 'Declarations',
          title: 'Declarations',
          defaultValue: {
            policy: 'false',
            sick: 'false',
            contagious: 'false',
            evacuation: 'false',
            payFees: 'false',
            weeklyFees: 'false',
            correctInfo: 'false',
            xplorForm: 'false'
          },
          isRequired: true,
          columns: [
            {
              value: 'true',
              text: 'Agree'
            },
            {
              value: 'false',
              text: 'Disagree'
            }
          ],
          rows: [
            {
              value: 'policy',
              text:
                'I have read and understood the services policies and procedures and agree to follow these as a condition of enrolment (available at the service or via your parent handbook).'
            },
            {
              value: 'sick',
              text:
                'Do you agree to collect or make arrangement for the collection of your child if they become unwell at the service?'
            },
            {
              value: 'contagious',
              text:
                ' Do you agree to keep your child away from the service if they display any symptom that could be considered contagious?'
            },
            {
              value: 'evacuation',
              text:
                'I give permission for my child to participate in regular evacuation drills or an actual evacuation when necessary. I understand that my child will be relocated from the service under the supervision of their educator and service team member to a safety zone for evacuation purposes.'
            },
            {
              value: 'payFees',
              text:
                'I am aware that I am required to pay my service fees in accordance with their policies and non-payment could result in cancellation of my child’s enrolment and recovery action may be undertaken at my expense.'
            },
            {
              value: 'weeklyFees',
              text:
                'I am aware that fees are charged weekly and non-payment could result in cancellation of my child\'s enrolment and recovery action may be undertaken at my expense.'
            },
            {
              value: 'correctInfo',
              text:
                'I declare that I am the applicant named in the form and that all information and documents provided as part of my application are true and correct.'
            },
            {
              value: 'xplorForm',
              text:
                'I understand that Xplor has provided a general enrolment form. Any difference or ambiguity between Xplor\'s enrolment form and the service\'s terms and conditions will be governed by the service\'s terms and conditions.'
            }
          ],
          isAllRowRequired: true
        },
        {
          type: 'text',
          name: 'XplorRequired_EddrCheck',
          titleLocation: 'hidden',
          validators: [
            {
              type: 'expression',
              text: 'Please answer the question',
              expression: 'validateCheck({XplorRequired_EddrCheck})'
            }
          ]
        },
        {
          type: 'html',
          name: 'Xplor_Captcha',
          isRequired: true
        }
      ]
    }
  ]
}

export default defaultSchema
